import script from "./NotificationCreateModal.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationCreateModal.vue?vue&type=script&setup=true&lang=js"

import "./NotificationCreateModal.vue?vue&type=style&index=0&id=337ea6c0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-337ea6c0"]])

export default __exports__